import { render, staticRenderFns } from "./processuser.vue?vue&type=template&id=0196d7c3&scoped=true&"
import script from "./processuser.vue?vue&type=script&lang=js&"
export * from "./processuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196d7c3",
  null
  
)

export default component.exports